import React, { useState } from 'react';
import { Alert, Button, CardContent, CardHeader, Typography } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import { useDispatch } from 'react-redux';
import { deleteVenue } from '../../../Redux/Action';
import { setModal } from '../../../../../Common/App';
import { DialogCard } from '../../../../../../Components/Cards/DialogCard';
import { Loader } from '../../../../../../Components';

export const DeleteVenueModal = ({ venue }) => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {

        if (!venue?.id) {
            return;
        }

        setIsLoading(true);
        await deleteVenue({ dispatch, id: venue.id }).then((res) => {
            if (res.success) {
                dispatch(setModal({ component: null, open: false }));
            }
            setIsLoading(false);
        });
    };

    return (
        <DialogCard>
            <CardHeader
                title="Delete Venue"
                avatar={<Loader isLoading={isLoading} type="linear" />}
            />
            <CardContent sx={{ p: 2, pt: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    You are about to delete the venue <strong>&quot;{venue?.venue_name}&quot;</strong>
                    {venue?.code ? (
                        <> (code: <strong>{venue.code}</strong>)</>
                    ) : null}.
                </Typography>
                <Alert severity="warning">
                    This action cannot be undone. Linked locations may be removed by the server. Are you sure?
                </Alert>
            </CardContent>
            <DialogActions sx={{ mb: 2, mr: 2, justifyContent: 'flex-end' }}>
                <Button onClick={() => dispatch(setModal({ component: null, open: false }))}>Cancel</Button>
                <Button disabled={isLoading} variant="contained" color="error" onClick={handleSubmit}>
                    Delete
                </Button>
            </DialogActions>
        </DialogCard>
    );
};
